// app info
const appId_ = 'bri-life-v3-4e197';
const appName_ = 'Reward Zone (QA)';
// app version
const appVersion_ = 'Ver.1.48.1.2021.01.15.000063';
// firebase
const firebaseConfig_ = {
  apiKey: "AIzaSyDJeWfXiINITFhek2YrTv_rFC9vjnId13g",
  authDomain: ["rewardzone.web.app", "bri-life-v3-4e197.web.app", "dev-custom-bri-life-work.local"],
  databaseURL: "https://bri-life-v3-4e197.firebaseio.com",
  projectId: "bri-life-v3-4e197",
  storageBucket: "bri-life-v3-4e197.appspot.com",
  messagingSenderId: "205729370529",
  appId: "1:205729370529:web:cb19fc7982c47ec9803be0",
  measurementId: "G-FLH63TJ0V4"
}
// (for email link)
const firebaseUrl_ = 'https://bri-life-v3-4e197.web.app';
const firebaseDynamicLinkDomain_ = 'brilifev34e197.page.link';
// (for getting firestore)
const firestoreLimitCount_ = 10;
// bo ipc
const ipcDomain_ = 'reward-zone';
const ipcUrl_ = 'https://' + ipcDomain_ + '.bo-point.id';
// bo ip cli
const ipCliUrl_ = 'https://rewardzone.ip-cli.bo-point.id';
// one signal
const oneSignalAppId_ = 'd4b86c4b-1008-4c76-8c26-79b6e392f5d7';
const oneSignalUrl_ = 'https://onesignal.com/api/v1/notifications';
// google chart
const googleChartMapsApiKey_ = 'AIzaSyCfTRNB4TzUe4VPlBrPB2k6XHBcqPMnlM8';
const googleChartColors_ = [ '#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#329262', '#5574A6', '#3B3EAC' ]
// log level
const logLevel_ = {
  error: true,
  warning: true,
  info: true,
  debug: true,
  dev: false // only logged on local log mode
}
// log mode
const logMode_ = {
  local: false,
  server: true
}
// environment
const env_ = {
  dev: false,
  release: false,
  qa: true
}
// build mode
const buildMode_ = true;
// debug mode
const debugMode_ = false;

export default {
  data() {
    return {
      appId: appId_,
      appName: appName_,
      appVersion: appVersion_,
      firebaseConfig: firebaseConfig_,
      firebaseUrl: firebaseUrl_,
      firebaseDynamicLinkDomain: firebaseDynamicLinkDomain_,
      firestoreLimitCount: firestoreLimitCount_,
      ipcDomain: ipcDomain_,
      ipcUrl: ipcUrl_,
      ipCliUrl: ipCliUrl_,
      oneSignalAppId: oneSignalAppId_,
      oneSignalUrl: oneSignalUrl_,
      googleChartMapsApiKey: googleChartMapsApiKey_,
      googleChartColors: googleChartColors_,
      logLevel: logLevel_,
      logMode: logMode_,
      env: env_,
      buildMode: buildMode_,
      debugMode: debugMode_
    }
  }
}